export class PreviousMaterialError extends Error {
  constructor(message) {
    super(message)
    this.name = 'PreviousMaterialError'
    this.message = message
  }
}
